import isElement from "lodash.iselement";

class Quantity {
  constructor({ base, limit = 0, onChange = () => {} }) {
    if (!isElement(base)) return;
    this.base = base;
    this.value = 0;
    this._init();
    this._limit = parseInt(limit);
    if (!Number.isInteger(this._limit)) return;
    this._callbacks = { onChange };
  }
  _init() {
    this._minusElement = this.base.querySelector(".quantity__minus");
    this._plusElement = this.base.querySelector(".quantity__plus");
    this._inputElement = this.base.querySelector(".quantity__value");
    if (!this._plusElement || !this._minusElement || !this._inputElement) return; 
    this._minusElement.addEventListener("click", this._decrease.bind(this));
    this._plusElement.addEventListener("click", this._increase.bind(this));
    this._inputElement.addEventListener("blur", this._onBlur.bind(this));
    this.setValue(this._inputElement.value, true);

    this._render();
  }
  _onInput() {
    if (this._inputElement.value === "") return;
    const parsedValue = parseInt(this._inputElement.value);
    if (Number.isInteger(parsedValue)) {
      this.setValue(parsedValue);
    }
    this._render();
  }
  _onBlur() {
    const parsedValue = parseInt(this._inputElement.value);
    if (Number.isInteger(parsedValue)) {
      this.setValue(parsedValue);
    } else {
      this.setValue(0);
    }
  }
  _increase(e) {
    e.preventDefault();
    this.setValue(this.value + 1);
  }
  _decrease(e) {
    e.preventDefault();
    this.setValue(this.value - 1);
  }
  setValue(newValue, disableOnChangeCallback) {
    newValue = parseInt(newValue);
    if (!Number.isInteger(newValue)) return;
    if (newValue < 0) newValue = 0;
    if (newValue > this._limit) newValue = this._limit;
    const needsToUpdate = newValue !== this.value && !disableOnChangeCallback;
    this.value = newValue;
    this._render();
    if (needsToUpdate) this._callbacks.onChange(newValue);
  }
  updateLimit(newLimit) {
    this._limit = newLimit;
    this.setValue(this.value);
  }
  _render() {
    this._inputElement.value = this.value;
  }
}

export default Quantity;



// WEBPACK FOOTER //
// ./src/js/components/quantity.js